/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invalid_CredentialsInputs */

const fr_api_invalid_credentials = /** @type {(inputs: Api_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les identifiants sont incorrects. Vérifiez-les et réessayez.`)
};

const en_api_invalid_credentials = /** @type {(inputs: Api_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in details are incorrect. Check them and try again.`)
};

/**
* | output |
* | --- |
* | "The sign-in details are incorrect. Check them and try again." |
*
* @param {Api_Invalid_CredentialsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invalid_credentials = /** @type {((inputs?: Api_Invalid_CredentialsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invalid_CredentialsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invalid_credentials(inputs)
	return fr_api_invalid_credentials(inputs)
});